import React from "react";
import { HintsLink } from "../../../modules/hints/components/HintsLink";

const DefaultTermsAndConditions = ({
  lang,
  companyName,
  domain,
  tenantServiceName,
  email,
  address,
}: {
  lang: string;
  companyName: string;
  domain: string;
  tenantServiceName: string;
  email: string;
  address: React.ReactNode;
}) => {
  if (lang === "de") {
    return (
      <div className="min-h-full px-5 text-foreground gap-4 flex flex-col text-base">
        <h1 className="font-semibold text-foreground/90 text-2xl leading-[28px] tracking-[-0.015em] text-center">
          Nutzungsbedingungen
        </h1>
        <p>
          <strong>Präambel</strong>
          <br />
          a. Der Eigentümer und Anbieter der Plattform ist {companyName}. Die
          Bereitstellung der Plattform erfolgt durch den Online-Plattform
          Betreiber „kolula“.
        </p>
        <p>
          b. Über die {tenantServiceName} können diverse Produkte und Geräte im
          Bereich von Sport- und Freizeit, Handwerk oder Haushalt gesucht,
          gebucht („Buchung“) und online bezahlt werden. Das Angebot wird von{" "}
          {companyName} <br />
          selbst, oder von Partnerunternehmen („Betreiber“) in
          Eigenverantwortung in eigenem Namen und auf eigene Rechnung umgesetzt.
        </p>
        <p>
          kolula unterstützt den Eigentümer mit dem kolula-System gegenüber den
          Nutzern dabei im Wesentlichen durch die übersichtliche Darstellung und
          Abwicklung des Buchungsangebots, aber nicht bei der Erfüllung des
          Nutzungs-/Dienstleistungsvertrages zwischen Betreiber und Nutzer.
        </p>
        <p>
          c. Begriffsbestimmungen für diese Nutzungsbedingungen/AGB: <br />
          Der Begriff „Nutzer“ beschreibt jene Personen (insb. Verbraucher), die
          die {tenantServiceName} Web-App nutzen und sich über die
          kolula-Plattform registriert haben. Der Begriff „kolula-System“
          umfasst die kolula-Plattform sowie sonstige Verwaltungs- und
          Buchungsdienste von kolula (online und offline). Der Begriff
          „Betreiber“ beschreibt jene natürliche oder juristische Person, die
          mit kolula einen Vertrag zur Inanspruchnahme des kolula-Systems als
          Anbieter von Sport- und Freizeitangeboten abgeschlossen hat
          („Partnervertrag“).
        </p>
        <p>
          d. Personenbezogene Daten (des Betreibers, seiner Kunden und seiner
          Mitarbeiter) im Sinne des Datenschutzgesetzes (insb. Telefonnummer,
          Adresse, Emailadresse, sonstige Inhaltsdaten etc.) werden gemäß der
          Datenschutzerklärung verarbeitet. Die Datenschutzerklärung ist unter{" "}
          <HintsLink href="https://www.kolula.com">www.kolula.com</HintsLink>{" "}
          abrufbar.
        </p>
        <h1 className="font-semibold text-foreground/90 text-2xl leading-[28px] tracking-[-0.015em] text-center">
          Allgemeine Geschäftsbedingungen der kolula solutions UG
        </h1>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          1. Geltungsbereich
        </h2>
        <p>
          Die nachfolgenden allgemeinen Geschäftsbedingungen („AGB“) gelten für
          die Inanspruchnahme von Lieferungen, Leistungen oder sonstigen
          Angeboten von
          <br />
          <br />
          {address}
          (im Folgenden auch „Anbieter“ oder „wir“) durch Sie (im Folgenden auch
          „Nutzer“ oder „Kunde“), für sämtliche Geschäftsbeziehungen zwischen
          Ihnen und uns, sowie für die Nutzung unserer Website <br />
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href={`https://${domain}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            https://{domain}
          </a>
          , (im Folgenden auch „Website“), unserer Progressive Web App „
          {tenantServiceName}“ (im Folgenden auch „App“), sowie unserer
          sonstigen Dienste.
          <br />
          <br />
          Abweichende Bedingungen erkennen wir nicht an, es sei denn, wir hätten
          ausdrücklich schriftlich ihrer Geltung zugestimmt. Wir behalten uns
          das Recht vor, die AGB jederzeit zu ändern.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          2. Nutzung
        </h2>
        <p>
          <strong>2.1 Nutzungsrechte</strong>
          <br />
          Dem User wird ein zeitlich und räumlich unbeschränktes, kostenloses
          Nutzungsrecht an der App, deren Informationen und Diensten eingeräumt.
          Das Nutzungsrecht wird ausschließlich für den eigenen Bedarf und im
          Rahmen der Nutzung der App und deren Diensten unter Ausschluss
          jeglicher anderen Zwecke gewährt.
          <br />
          <br />
          Es ist dem User gestattet, Angebote in der App zu suchen, Angebote
          unter den Vermietungsstationen zu vergleichen und mit einem Anbieter
          Verträge abzuschließen.
          <br />
          <br />
          Hierfür ist der User verpflichtet, wahrheitsgetreue und vollständige
          Angaben für die Erfassung der Daten beim Anmeldeprozess anzugeben.
          <br />
          <br />
          Wenn Inhalte, die durch die vom Anbieter zustehenden geistigen
          Eigentumsrechte geschützt sind, durch den User verwendet werden,
          bleiben sämtliche Rechte hinsichtlich dieser Inhalte dem Anbieter
          erhalten. Die Verwendung von Urheberrechten und/oder Marken des
          Anbieters ist nicht gestattet.
          <br />
          <br />
          Der User darf namentlich die Inhalte der App nicht dazu verwenden, um
          diese in irgendwelcher Form zu ändern, zu kopieren, herunterzuladen,
          nachzukonstruieren, zu duplizieren, zu publizieren oder zu vertreiben.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          3. Angebote und Leistungsbeschreibungen
        </h2>
        <p>
          <strong>3.1 {tenantServiceName} - Plattform</strong>
          <br />
          Über die Buchungsplattform bieten wir Ihnen unterschiedliche
          Haushalts- und Freizeitgeräte inkl. Zubehör zur personalfreien
          Vermietung an unseren digitalen Verleihstationen an. Über die
          Plattform können das Angebot sowie die jeweiligen Verfügbarkeiten
          eingesehen werden. Bei Bedarf können die benötigten Geräte ausgewählt
          und für den gewünschten Zeitraum reserviert und gebucht werden. Die
          Reservierung sowie die Entnahme der Produkte kann ausschließlich über
          die im Buchungsprozess ausgewählte Verleihstation erfolgen und ist an
          den jeweils zuvor angegebenen Zeitraum gebunden.
        </p>
        <p>
          <strong>3.2 {tenantServiceName} - Verleihstationen</strong>
          <br />
          Die über die Plattform angebotenen Produkte sind an verschiedenen
          Standorten in unseren digitalisierten Verleihstationen -
          {tenantServiceName}- hinterlegt und können nur über die Plattform
          gebucht und abgerufen werden. Das jeweilige Angebot kann gemäß der
          Kundenwünsche sowie der Anzahl der Fächer je nach Standort variieren.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          4. Persönliche Teilnahmevoraussetzungen, Bestellvorgang und
          Vertragsabschluss
        </h2>
        <p>
          <strong>4.1 Inanspruchnahme der Leistungen</strong>
          <br />
          Sie können unsere Leistungen über den Online-Buchungsmanager auf
          unserer Website,{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href={`https://${domain}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            https://{domain}
          </a>
          , in Anspruch nehmen.
          <br />
          <br />
          Sie müssen für den Abschluss einer Buchung volljährig sein. Wenn Sie
          minderjährige Personen an der Nutzung unserer Leistungen teilhaben
          lassen, erklären Sie, dass die erforderliche Zustimmung der
          gesetzlichen Vertreter vorliegt. Wir setzen bei der Auswahl der
          Produkte voraus, dass ein konkreter Bedarf für die Nutzung dieser
          vorliegt.
          <br />
          <br />
          Wir behalten uns vor, individuelle Regeln für die Buchung und Entnahme
          einzelner Geräte festzulegen, je nach Anwendungsbereich.
          <br />
          <br />
          Wir empfehlen allen Kunden, sich vor Abschluss der Buchung mit der
          Handhabung und den Anwendungsmöglichkeiten der jeweiligen Geräte
          auseinanderzusetzen, unabhängig von der Produktkategorie. Die spätere
          Anwendung der Geräte erfolgt in eigener Verantwortung.
          <br />
          <br />
          Während des gesamten Buchungszeitraums sind die Kunden verantwortlich
          für den Zustand der gebuchten Geräte und verpflichten sich, diese in
          einem funktionsfähigen Zustand zurückzugeben. Eventuelle Schäden oder
          Funktionsfehler müssen dem Anbieter umgehend gemeldet werden.
          <br />
          <br />
          Mit der Buchung erklären Sie, dass für alle Teilnehmer die genannten
          Voraussetzungen erfüllt sind.
          <br />
          <br />
          Der Anbieter behält sich vor, einzelne Kunden temporär und/oder
          dauerhaft von der Nutzung auszuschließen, sollte es zu einer
          Verletzung der Voraussetzungen kommen.
        </p>
        <p>
          <strong>4.2 Buchung unserer Leistung „Vermietung“</strong>
          <br />
          Wählen Sie in der App den gewünschten Ort aus, um zur Produktauswahl
          zu gelangen. Nicht verliehene Artikel sind mit „sofort verfügbar“
          gekennzeichnet und können ohne Wartezeit direkt ausgeliehen werden.
          Bereits verliehene Artikel sind mit „reserviert“ gekennzeichnet und
          können erst wieder gebucht werden, sobald die vorherige Buchung
          abgeschlossen ist.
          <br />
          <br />
          Wählen Sie die gewünschten Artikel aus und klicken Sie auf „BUCHEN“.
          Wählen Sie anschließend Datum und Dauer der Buchung aus. Über die
          Schaltfläche „Weiter“ gelangen Sie zum nächsten Schritt, dort teilen
          Sie uns Ihren Vornamen, Nachnamen, Mobiltelefon-Nr. sowie Ihre E-Mail
          mit. Anschließend gelangen Sie über die Schaltfläche „Weiter“ zur
          Übersicht und Auswahl der Zahlmethode. Über die Schaltfläche
          „Bestellen“ gelangen Sie in den Bezahlprozess. Hierdurch geben Sie
          einen verbindlichen Antrag zum zahlungspflichtigen Abruf der im
          Warenkorb befindlichen Leistungen ab. Vor Abschicken der Bestellung
          können Sie die eingegebenen Daten jederzeit ändern. Mit der
          Schaltfläche „zurück“ können Sie zur Eingabe Ihrer Kontaktdaten sowie
          zur Auswahl der Leistung zurückkehren oder den Bestellvorgang
          insgesamt abbrechen.
          <br />
          <br />
          Nach erfolgreicher Prüfung ist der Bestellvorgang abgeschlossen.
          <br />
          <br />
          Nach Abschicken der Bestellung erhalten Sie eine Eingangsbestätigung
          per E-Mail zu Ihrer Bestellnummer.
          <br />
          <br />
          Sie erhalten anschließend eine Buchungsbestätigung per E-Mail mit dem
          Buchungslink und dem Kaufbeleg. Sollten Sie über einen Desktop-PC die
          Buchung ausgeführt haben, können Sie mittels des Buchungslinks Ihre
          gebuchte Leistung auf Ihr Mobiltelefon übertragen. Mit dem Versand der
          Buchungsbestätigung ist der Vertrag zwischen Ihnen und uns wirksam
          zustande gekommen.
          <br />
          <br />
          Der Anbieter ist verpflichtet, die gewählten Produkte gemäß der
          Buchung zu reservieren und die Verfügbarkeit zum Zeitpunkt der
          Entnahme zu garantieren.
          <br />
          <br />
          Ab dem Zeitpunkt der Entnahme können die Kunden für die gesamte
          Buchungsdauer über die Produkte verfügen. Auch bei einer vorzeitigen
          Rückgabe haben Kunden die Möglichkeit, die Produkte erneut zu
          entnehmen und bis zur vorgegebenen Rückgabezeit zu nutzen. Die
          Rückgabe erfolgt am gleichen Standort, wie die Entnahme.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          5. Zahlungsmodalitäten und Preise
        </h2>
        <p>
          Sie haben die Möglichkeit, zwischen Zahlung per Kreditkarte oder per
          PayPal zu wählen. Die jeweils gültigen Preise für unsere Leistungen
          finden Sie auf unserer Website. Der aufgeführte Preis ist der Endpreis
          inkl. der jeweils gültigen gesetzlichen MwSt.
        </p>

        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          6. Stornoregelung, Rücktritt und Überschreitung der Buchungszeit
        </h2>
        <p>
          <strong>6.1 Terminverschiebung</strong>
          Wir bieten Ihnen die Möglichkeit, den gewählten Termin bis
          einschließlich 48 Stunden vor Beginn des Termins zu ändern
          (Terminverschiebung). Bitte kontaktieren Sie uns unter{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href={`mailto:${email}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {email}
          </a>
          .
        </p>
        <p>
          <strong>6.2 Stornierung</strong>
          <br />
          Im Fall einer Stornierung bis einschließlich zum 3. Tag vor dem Tag
          der Leistungsdurchführung erhalten Sie von uns eine Erstattung in Höhe
          von 90% des bezahlten Betrages, die Sie wahlweise als Gelderstattung
          oder in Form eines Wertgutscheins erhalten.
          <br />
          <br />
          Im Fall einer späteren Stornierung (ab 47 Stunden bis zum Beginn des
          Termins) können wir eine Erstattung oder eine Terminverschiebung nicht
          anbieten.
          <br />
          <br />
          Sollten Sie für Ihre Buchung einen Gutschein eingesetzt haben, kann
          die Erstattung gemäß obenstehenden Bedingungen nur gegen Ausgabe eines
          Wertgutscheins, nicht jedoch in Form einer Gelderstattung erfolgen.
        </p>
        <p>
          <strong>6.3 Höhere Gewalt</strong>
          <br />
          Sollte aufgrund von witterungsbedingten Umständen (Sturmschäden,
          starker Frost, etc.) oder Vandalismusschäden sowie sonstigen
          technischen Problemen Ihre Buchung nicht durchführbar sein (im
          Folgenden „höhere Gewalt“), haben Sie das Recht, vom Vertrag
          zurückzutreten. Sofern ein Fall der höheren Gewalt tatsächlich
          vorliegt, werden wir Ihnen die bezahlten Beträge zurückerstatten.
          Bitte haben Sie Verständnis, dass diese Entscheidung durch uns als
          Anbieter im Einzelfall getroffen wird.
          <br />
          <br />
          Bei Unsicherheit über die Durchführbarkeit der Leistung erreichen Sie
          uns per E-Mail{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href={`mailto:${email}`}
          >
            {email}
          </a>{" "}
          oder per Telefon zur Abstimmung.
        </p>
        <p>
          <strong>6.4 Rücktritt vom Vertrag</strong>
          <br />
          Der Anbieter hat das Recht, bei Vorliegen sonstiger Gründe, die der
          Durchführbarkeit der Leistung entgegenstehen, vom Vertrag
          zurückzutreten. Sie erhalten in diesem Fall eine Erstattung der
          bezahlten Beträge in Geld. Schadensersatzansprüche Ihrerseits wegen
          der Nichtdurchführung der Leistung sind ausgeschlossen.
        </p>
        <p>
          <strong>6.5 Überschreitung der Buchungszeit</strong>
          <br />
          Bei Überschreitung der Buchungszeit behalten wir uns vor, für die
          jeweils angefangene Stunde die volle Stunde zum aktuell gültigen
          Stundenpreis nachzuberechnen, zuzüglich einer Bearbeitungsgebühr in
          Höhe von 10,00€ inkl. aktuell gültiger MwSt.
          <br />
          <br />
          Bei verspäteter Rückgabe haftet der Mieter außerdem für eventuelle
          Folgeschäden. Dies gilt insbesondere für den Fall, dass durch die
          verspätete Rückgabe ein anderer Kunde Wartezeiten hinnehmen muss. Für
          den Fall, dass nachfolgende Kunden ihre Buchung aufgrund der
          Verspätung widerrufen, hat der verspätete Kunde den Ausfall zu
          kompensieren.
          <br />
          <br />
          Bei nicht fristgerechter Rückgabe der gemieteten Produkte behält sich
          der Anbieter eine Anzeige wegen Unterschlagung gegen den Kunden sowie
          weitere rechtliche Schritte vor.
          <br />
          <br />
          Die verspätete Ausgabe gebuchten Verleih-Materials, die der Anbieter
          nicht zu vertreten hat, berechtigen den Kunden nicht zur
          Überschreitung des gebuchten Zeitraums. Eine vorzeitige Rückgabe
          berechtigt nicht zur Rückforderung des Mietpreises. Für den Fall einer
          verkürzten Nutzungsdauer erhält der Kunde einen Gutschein bzw. den
          Buchungspreis zeitanteilig erstattet. Erscheint ein Kunde nicht zu
          einem gebuchten Termin, sind wir ab einer Verspätung von mehr als 15
          Minuten berechtigt, das Material anderweitig zu vergeben.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          7. Widerrufsbelehrung
        </h2>
        <p>
          Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu
          Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch
          ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können.
        </p>
        <p>
          <strong>7.1 Widerrufsrecht</strong>
          <br />
          Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen
          diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage
          ab dem Tag des Vertragsschlusses. Um Ihr Widerrufsrecht auszuüben,
          müssen Sie uns mittels einer eindeutigen Erklärung (z.B. ein mit der
          Post versandter Brief oder E-Mail) über Ihren Entschluss, diesen
          Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte
          Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist. Zur
          Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über
          die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist
          absenden.
        </p>
        <p>
          <strong>7.2 Folgen des Widerrufs</strong>
          <br />
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen,
          die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit
          Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie
          eine andere Art der Lieferung als die von uns angebotene, günstigste
          Standardlieferung gewählt haben), unverzüglich und spätestens binnen
          vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über
          Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese
          Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der
          ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen
          wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden
          Ihnen wegen dieser Rückzahlung Entgelte berechnet.
        </p>
        <p>
          <strong>
            7.3 Ausschluss bzw. vorzeitiges Erlöschen des Widerrufsrechts
          </strong>
          <br />
          Das Widerrufsrecht besteht nicht bei Verträgen zur Erbringung von
          Dienstleistungen im Zusammenhang mit Freizeitbetätigungen, wenn der
          Vertrag für die Erbringung einen spezifischen Termin oder Zeitraum
          vorsieht.
          <br />
          <br />
          Gemäß § 312g Abs. 2 Nr. 9 BGB besteht kein Widerrufsrecht für die von
          Ihnen getätigte Buchung unserer Leistungen „Vermietung“.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          8. Teilnahme an unseren Leistungen
        </h2>
        <p>
          <strong>8.1 Buchung</strong>
          <br />
          Sie haben mit Ihrer Buchung die, von Ihnen ausgewählten, Geräte von
          uns zur Vermietung reserviert. Bitte rufen Sie Ihren Buchungslink auf.
          Ihnen wird angezeigt, in welchem Schließfach der von Ihnen gewählten
          {tenantServiceName} die gebuchten Geräte für Sie bereit liegen. Sie
          können das Schließfach frühestens 15 Minuten vor Beginn der
          Nutzungszeit öffnen und das Produkt entnehmen.
          <br />
          <br />
          Sie sind aufgefordert, den Zustand des Produktes vor der Entnahme auf
          etwaige Schäden und Vollständigkeit zu prüfen und dies vorab zu
          bestätigen. Sollten Sie Schäden oder sonstige Einschränkungen
          feststellen, melden Sie diese binnen der ersten 10 Minuten der
          Nutzungszeit unter Verwendung der Funktion „Schaden melden“.
          <br />
          <br />
          Diese finden Sie in der Ansicht der Station unter (i). Sie können in
          das Textfeld Ihre Feststellung eingeben und die Schadensmeldung durch
          Klicken auf „Bestätigen“ an uns absenden.
          <br />
          <br />
          Alternativ können Sie beim Kundensupport anrufen, der die Buchung dann
          ändert und das betreffende Material sperrt. Sofern die Schäden die
          Nutzbarkeit des Produkts nicht beeinträchtigen, kann die Buchung im
          Regelfall fortgesetzt werden, andernfalls legen Sie nach Durchführung
          der Schadensmeldung das Material zurück in das Schließfach und beenden
          Sie die Nutzungszeit. In diesem Fall erhalten Sie, sofern verfügbar,
          Zugriff auf ein Ausweichprodukt erhalten. Sollte kein
          Alternativprodukt verfügbar sein, so erhalten Sie automatisch eine
          Gutschrift über den gebuchten Betrag.
          <br />
          <br />
          Sollten Sie hierzu Fragen haben, erreichen Sie uns durchgehend unter
          den in der App angegebenen Kontaktmöglichkeiten.
          <br />
          <br />
          Sofern Sie in den ersten 10 Minuten der Nutzungszeit keine
          Schadensmeldung abgeben, gehen wir davon aus, dass das von Ihnen
          vorgefundene Produkt vollständig und unbeschädigt im Schließfach
          vorgefunden wurde.
        </p>
        <p>
          <strong>8.2 Ablauf der Nutzungszeit</strong>
          <br />
          Bitte geben Sie die gemieteten Produkte mit Ablauf der Nutzungszeit
          pünktlich, vollständig und in einem sauberen Zustand zurück, indem Sie
          dieses in das Schließfach zurücklegen und die Nutzungszeit durch
          Klicken auf die Schaltfläche „Miete Beenden“ und anschließendes Wählen
          der Option „Türen öffnen & Miete beenden“ abschließen. Mit Abschluss
          der Miete bestätigen Sie, dass während Ihres Buchungszeitraums keine
          weiteren Schäden an den Produkten entstanden. Sollte während der
          Nutzungszeit ein Schaden an den gemieteten Produkten entstehen oder
          Teile des Materials verloren gehen bzw. abhandenkommen, müssen Sie uns
          dies mitteilen. Bitte verwenden Sie hierzu die Funktion „Schaden
          melden“. Sie können das aufgetretene Problem in dem hierfür
          bereitgestellten Textfeld darstellen.
          <br />
          <br />
          Wird eine Miete nicht ordnungsgemäß, wie hier beschrieben beendet,
          behalten wir uns vor, die Zeit der Überbuchung nachzuberechnen,
          zuzüglich einer Bearbeitungsgebühr in Höhe von 7,90€ inkl. aktuell
          gültiger MwSt.
          <br />
          <br />
          Nach dem Ende der Nutzungszeit können Sie das Schließfach für weitere
          15 Minuten öffnen, in denen Sie das gemietete Material zurücklegen
          können. Nach Ablauf der Rückgabezeit können sie das Schließfach nicht
          mehr öffnen. Bitte beachten Sie, dass von Ihnen im Schließfach
          abgelegte persönliche Gegenstände zuvor entnommen werden.
          <br />
          <br />
          Schäden des Anbieters aufgrund von Überschreitung der Nutzungszeit hat
          der Nutzer zu erstatten, auch, soweit die Überschreitung durch einen
          weiteren Teilnehmer erfolgt (siehe 6.5. dieser AGBs).
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          9. Verhaltensregeln und Haftung des Nutzers
        </h2>
        <p>
          <strong>9.1 Sicherheit und Betriebsbereitschaft der Produkte</strong>
          <br />
          Die Sicherheit und Betriebsbereitschaft der Produkte werden durch
          regelmäßige Inspektionen sichergestellt. Sie verpflichten sich, die
          Mietgegenstände mit Sorgfalt zu behandeln. Schäden und
          Verschmutzungen, die während Ihrer Nutzungszeit auftreten, werden auf
          Ihre Kosten entfernt. Die Kosten für den Ersatz beschädigten oder
          abhanden gekommenen Materials (auch Diebstahl) werden Ihnen
          weiterberechnet. Zur Schadensmeldungspflicht siehe oben unter 6.3.
          <br />
          <br />
          Treten unvorhergesehene Umstände ein, die eine rechtzeitige Rückgabe
          der Mietsache unmöglich machen, so sind Sie verpflichtet, uns umgehend
          davon in Kenntnis zu setzen, damit eine einfache und kostengünstige
          Lösung herbeigeführt werden kann. Etwaig entstehende Bergungskosten
          haben Sie als Nutzer zu tragen.
          <br />
          <br />
          Sofern Sie unsere Leistungen für mehrere Personen gebucht haben,
          haften Sie gesamtschuldnerisch mit den jeweils haftenden Teilnehmern.
          Sollte der Schadensverursacher nicht zu ermitteln sein, haften Sie
          allein, es sei denn, Sie weisen nach, dass der Schaden nicht aus dem
          Kreis der von Ihnen gewählten Teilnehmer verursacht oder mit
          verursacht wurde.
        </p>
        <p>
          <strong>
            9.4 Nutzung ausschließlich gemäß dem vorgesehenen Zweck
          </strong>
          <br />
          Bitte beachten Sie, die jeweiligen Produkte nur gemäß ihres
          vorgesehenen Zwecks zu verwenden. Sollte Unklarheit über die Anwendung
          bestehen, bitte lesen vorab die beigefügten Gebrauchsanweisungen oder
          informieren Sie sich anderweitig über die korrekte Nutzung der
          jeweiligen Produkte. Der Anbieter übernimmt keine Haftung im Falle von
          Schadensfällen, die durch Anwendungsfehler des Nutzers verursacht
          wurden. Der Nutzer stellt den Anbieter von sämtlichen Ansprüchen
          aufgrund von Unfällen, aus der Verletzung von Gesetzen, Verordnungen
          oder sonstigen Vorschriften im Zusammenhang mit der Inanspruchnahme
          unserer Leistungen durch ihn oder einen anderen Teilnehmer an dieser
          Leistung frei. Wir weisen auf die gesamtschuldnerische Haftung des
          Nutzers mit weiteren Teilnehmern der Leistung hin.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          10. Haftung des Anbieters
        </h2>
        <p>
          Der Anbieter haftet für die leicht fahrlässige Verletzung von
          wesentlichen Pflichten, deren Verletzung die Erreichung des
          Vertragszwecks gefährdet, oder für die Verletzung von Pflichten, deren
          Erfüllung die ordnungsgemäße Durchführung des Vertrages überhaupt erst
          ermöglicht und auf deren Einhaltung der Nutzer regelmäßig vertraut. In
          diesen Fällen haftet der Anbieter jedoch nur für den vorhersehbaren,
          vertragstypischen Schaden. Der Anbieter haftet nicht für die leicht
          fahrlässige Verletzung anderer als der in den vorstehenden Sätzen
          genannten Pflichten. Die vorstehenden Haftungsbeschränkungen geltend
          nicht bei Verletzung von Leben, Körper und Gesundheit, für einen
          Mangel nach Übernahme einer Garantie für die Beschaffenheit des
          Produktes und bei arglistig verschwiegenen Mängeln. Die Haftung nach
          dem Produkthaftungsgesetz bleibt unberührt.
          <br />
          <br />
          Soweit die Haftung des Verkäufers ausgeschlossen oder beschränkt ist,
          gilt dies auch für die persönliche Haftung von Arbeitnehmern,
          Vertretern und Erfüllungsgehilfen.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          11. Schlussbestimmungen
        </h2>
        <p>
          Gerichtsstand und Erfüllungsort ist der Sitz des Anbieters, soweit
          sich aus dem geltenden Recht nicht etwas anderes ergibt. Die
          Vertragssprache ist deutsch. Es bestehen keine mündlichen
          Nebenabreden. Sämtliche Änderungen und Ergänzungen dieser AGB bedürfen
          der Textform, wobei E-Mail genügt. Sollten einzelne oder mehrere
          Bestimmungen dieses Vertrages unwirksam oder nichtig sein, so berührt
          dies nicht die Wirksamkeit des Vertrages in seinen übrigen
          Bestimmungen. Etwaige Lücken werden durch diejenige Bestimmung
          ersetzt, die dem mutmaßlichen Willen der Parteien am nächsten kommt.
          Plattform der Europäischen Kommission zur Online-Streitbeilegung (OS)
          für Verbraucher:{" "}
          <HintsLink
            className="underline underline-offset-2 hover:decoration-primary"
            href="http://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            http://ec.europa.eu/consumers/odr/
          </HintsLink>
          . Wir sind nicht bereit und nicht verpflichtet, an einem
          Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
          teilzunehmen.
        </p>

        <p className="italic text-sm">
          Stand der AGB: 11.07.2025 {companyName}
        </p>
      </div>
    );
  } else {
    return (
      <div className="min-h-full px-5 text-foreground gap-4 flex flex-col text-base">
        <h1 className="font-semibold text-foreground/90 text-2xl leading-[28px] tracking-[-0.015em] text-center">
          Terms and Conditions
        </h1>
        <p>
          <strong>Preamble</strong>
          <br />
          a. The owner and provider of the platform is {companyName}. The
          platform is provided by the online platform operator "kolula".
        </p>
        <p>
          b. Through {tenantServiceName}, various products and devices in the
          areas of sports and leisure, crafts or household can be searched,
          booked ("Booking") and paid for online. The offer is implemented by{" "}
          {companyName} itself, or by partner companies ("Operators") on their
          own responsibility, in their own name and on their own account.
        </p>
        <p>
          kolula supports the owner with the kolula system towards users
          essentially through the clear presentation and processing of the
          booking offer, but not in the fulfillment of the usage/service
          contract between operator and user.
        </p>
        <p>
          c. Definitions for these terms and conditions/T&C: <br />
          The term "User" describes those persons (especially consumers) who use
          the {tenantServiceName} web app and have registered via the kolula
          platform. The term "kolula system" includes the kolula platform as
          well as other administrative and booking services from kolula (online
          and offline). The term "Operator" describes that natural or legal
          person who has concluded a contract with kolula for using the kolula
          system as a provider of sports and leisure offers ("Partner
          contract").
        </p>
        <p>
          d. Personal data (of the operator, his customers and his employees)
          within the meaning of the data protection law (especially telephone
          number, address, email address, other content data, etc.) are
          processed in accordance with the privacy policy. The privacy policy is
          available at{" "}
          <HintsLink href="https://www.kolula.com">www.kolula.com</HintsLink>.
        </p>
        <h1 className="font-semibold text-foreground/90 text-2xl leading-[28px] tracking-[-0.015em] text-center">
          General Terms and Conditions of kolula solutions UG
        </h1>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          1. Scope of Application
        </h2>
        <p>
          The following general terms and conditions ("T&C") apply to the use of
          deliveries, services or other offers from
          <br />
          <br />
          {address}
          (hereinafter also "Provider" or "we") by you (hereinafter also "User"
          or "Customer"), for all business relationships between you and us, as
          well as for the use of our website{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href={`https://${domain}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            https://{domain}
          </a>
          , (hereinafter also "Website"), our Progressive Web App "
          {tenantServiceName}" (hereinafter also "App"), as well as our other
          services.
          <br />
          <br />
          validity in writing. We reserve the right to change the T&C at any
          time.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          2. Usage
        </h2>
        <p>
          <strong>2.1 Usage Rights</strong>
          <br />
          The user is granted unlimited, free usage rights to the app, its
          information and services, both temporally and geographically. The
          usage rights are granted exclusively for personal use and within the
          framework of using the app and its services, excluding any other
          purposes.
          <br />
          <br />
          The user is permitted to search for offers in the app, compare offers
          among rental stations and conclude contracts with a provider.
          <br />
          <br />
          For this purpose, the user is obligated to provide truthful and
          complete information for data collection during the registration
          process.
          <br />
          <br />
          When content protected by the provider's intellectual property rights
          is used by the user, all rights regarding this content remain with the
          provider. The use of copyrights and/or trademarks of the provider is
          not permitted.
          <br />
          <br />
          Specifically, the user may not use the content of the app to modify,
          copy, download, reverse engineer, duplicate, publish or distribute it
          in any form.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          3. Offers and Service Descriptions
        </h2>
        <p>
          <strong>3.1 {tenantServiceName} - Platform</strong>
          <br />
          Through the booking platform, we offer you various household and
          leisure equipment including accessories for unmanned rental at our
          digital rental stations. The offers and respective availability can be
          viewed on the platform. If needed, the required equipment can be
          selected and reserved and booked for the desired period. The
          reservation and collection of products can only be made through the
          rental station selected in the booking process and is bound to the
          previously specified time period.
        </p>
        <p>
          <strong>3.2 {tenantServiceName} - Rental Stations</strong>
          <br />
          The products offered through the platform are stored at various
          locations in our digitized rental stations -{tenantServiceName}- and
          can only be booked and retrieved through the platform. The respective
          offer may vary according to customer wishes and the number of
          compartments depending on the location.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          4. Personal Participation Requirements, Ordering Process and Contract
          Conclusion
        </h2>
        <p>
          <strong>4.1 Use of Services</strong>
          <br />
          You can use our services through the online booking manager on our
          website,{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href={`https://${domain}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            https://{domain}
          </a>
          .
          <br />
          <br />
          You must be of legal age to complete a booking. If you allow minors to
          participate in the use of our services, you declare that the required
          consent of the legal representatives is available. When selecting
          products, we assume that there is a concrete need for their use.
          <br />
          <br />
          We reserve the right to establish individual rules for booking and
          collection of individual devices, depending on the area of
          application.
          <br />
          <br />
          We recommend that all customers familiarize themselves with the
          handling and application possibilities of the respective devices
          before completing the booking, regardless of the product category. The
          subsequent use of the devices is at your own responsibility.
          <br />
          <br />
          During the entire booking period, customers are responsible for the
          condition of the booked devices and commit to returning them in
          working condition. Any damage or malfunctions must be reported to the
          provider immediately.
          <br />
          <br />
          With the booking, you declare that the mentioned requirements are
          fulfilled for all participants.
          <br />
          <br />
          The provider reserves the right to temporarily and/or permanently
          exclude individual customers from use should there be a violation of
          the requirements.
        </p>
        <p>
          <strong>4.2 Booking our "Rental" Service</strong>
          <br />
          Select the desired location in the app to access the product
          selection. Items not rented out are marked as "immediately available"
          and can be borrowed directly without waiting time. Items already
          rented out are marked as "reserved" and can only be booked again once
          the previous booking is completed.
          <br />
          <br />
          Select the desired items and click "BOOK". Then select the date and
          duration of the booking. Use the "Next" button to proceed to the next
          step, where you share your first name, last name, mobile phone number
          and email with us. Then use the "Next" button to proceed to the
          overview and payment method selection. Use the "Order" button to enter
          the payment process. By doing so, you submit a binding request for the
          paid retrieval of the services in the shopping cart. Before sending
          the order, you can change the entered data at any time. With the
          "back" button, you can return to entering your contact data as well as
          to selecting the service or cancel the ordering process altogether.
          <br />
          <br />
          After successful verification, the ordering process is completed.
          <br />
          <br />
          After sending the order, you will receive a confirmation of receipt by
          email with your order number.
          <br />
          <br />
          You will then receive a booking confirmation by email with the booking
          link and receipt. If you have made the booking via a desktop PC, you
          can transfer your booked service to your mobile phone using the
          booking link. With the sending of the booking confirmation, the
          contract between you and us has been effectively concluded.
          <br />
          <br />
          The provider is obligated to reserve the selected products according
          to the booking and guarantee availability at the time of collection.
          <br />
          <br />
          From the time of collection, customers can use the products for the
          entire booking duration. Even with early return, customers have the
          possibility to collect the products again and use them until the
          specified return time. The return takes place at the same location as
          the collection.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          5. Payment Terms and Prices
        </h2>
        <p>
          You have the option to choose between payment by credit card or
          PayPal. The current valid prices for our services can be found on our
          website. The listed price is the final price including the applicable
          statutory VAT.
        </p>

        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          6. Cancellation Policy, Withdrawal and Exceeding Booking Time
        </h2>
        <p>
          <strong>6.1 Appointment Rescheduling</strong>
          We offer you the possibility to change the selected appointment up to
          and including 48 hours before the start of the appointment
          (appointment rescheduling). Please contact us at{" "}
           <a
            className="underline underline-offset-2 hover:decoration-primary"
            href={`mailto:${email}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {email}
          </a>
          .
        </p>
        <p>
          <strong>6.2 Cancellation</strong>
          <br />
          In case of cancellation up to and including the 3rd day before the day
          of service delivery, you will receive a refund of 90% of the paid
          amount from us, which you can receive either as a money refund or in
          the form of a voucher.
          <br />
          <br />
          In case of a later cancellation (from 47 hours until the start of the
          appointment), we cannot offer a refund or appointment rescheduling.
          <br />
          <br />
          If you have used a voucher for your booking, the refund according to
          the above conditions can only be made by issuing a voucher, but not in
          the form of a money refund.
        </p>
        <p>
          <strong>6.3 Force Majeure</strong>
          <br />
          Should your booking not be feasible due to weather-related
          circumstances (storm damage, severe frost, etc.) or vandalism damage
          as well as other technical problems (hereinafter "force majeure"), you
          have the right to withdraw from the contract. If a case of force
          majeure actually exists, we will refund the paid amounts to you.
          Please understand that this decision is made by us as the provider on
          a case-by-case basis.
          <br />
          <br />
          If you are uncertain about the feasibility of the service, you can
          reach us by email at{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href={`mailto:${email}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {email}
          </a>{" "}
          or by phone for coordination.
        </p>
        <p>
          <strong>6.4 Withdrawal from Contract</strong>
          <br />
          The provider has the right to withdraw from the contract in the
          presence of other reasons that prevent the feasibility of the service.
          In this case, you will receive a refund of the paid amounts in money.
          Claims for damages on your part due to non-performance of the service
          are excluded.
        </p>
        <p>
          <strong>6.5 Exceeding Booking Time</strong>
          <br />
          In case of exceeding the booking time, we reserve the right to charge
          the full hour at the currently valid hourly rate for each started
          hour, plus a processing fee of €10.00 including currently valid VAT.
          <br />
          <br />
          In case of late return, the renter is also liable for any
          consequential damages. This applies particularly in case that another
          customer has to accept waiting times due to the late return. In case
          that subsequent customers cancel their booking due to the delay, the
          late customer must compensate for the loss.
          <br />
          <br />
          In case of non-timely return of the rented products, the provider
          reserves the right to file a report for embezzlement against the
          customer as well as further legal steps.
          <br />
          <br />
          The late delivery of booked rental material, which the provider is not
          responsible for, does not entitle the customer to exceed the booked
          period. Early return does not entitle to claim back the rental price.
          In case of shortened usage duration, the customer receives a voucher
          or the booking price refunded proportionally. If a customer does not
          appear for a booked appointment, we are entitled to assign the
          material elsewhere from a delay of more than 15 minutes.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          7. Right of Withdrawal Information
        </h2>
        <p>
          A consumer is any natural person who concludes a legal transaction for
          purposes that can predominantly be attributed neither to their
          commercial nor their independent professional activity.
        </p>
        <p>
          <strong>7.1 Right of Withdrawal</strong>
          <br />
          You have the right to withdraw from this contract within fourteen days
          without giving any reason. The withdrawal period is fourteen days from
          the day of the conclusion of the contract. To exercise your right of
          withdrawal, you must inform us of your decision to withdraw from this
          contract by means of a clear statement (e.g. a letter sent by post or
          email). You may use the attached withdrawal form for this purpose, but
          it is not mandatory. To meet the withdrawal deadline, it is sufficient
          that you send your communication concerning your exercise of the right
          of withdrawal before the withdrawal period has expired.
        </p>
        <p>
          <strong>7.2 Effects of Withdrawal</strong>
          <br />
          If you withdraw from this contract, we shall reimburse to you all
          payments received from you, including the costs of delivery (with the
          exception of the supplementary costs resulting from your choice of a
          type of delivery other than the least expensive type of standard
          delivery offered by us), without undue delay and in any event not
          later than 14 days from the day on which we are informed about your
          decision to withdraw from this contract. We will carry out such
          reimbursement using the same means of payment as you used for the
          initial transaction, unless you have expressly agreed otherwise; in
          any event, you will not incur any fees as a result of such
          reimbursement.
        </p>
        <p>
          <strong>
            7.3 Exclusion or Premature Expiry of the Right of Withdrawal
          </strong>
          <br />
          The right of withdrawal does not exist for contracts for the provision
          of services related to leisure activities, if the contract provides
          for the provision on a specific date or period.
          <br />
          <br />
          According to § 312g Para. 2 No. 9 BGB, there is no right of withdrawal
          for your booking of our "Rental" services.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          8. Participation in Our Services
        </h2>
        <p>
          <strong>8.1 Booking</strong>
          <br />
          With your booking, you have reserved the devices selected by you from
          us for rental. Please call up your booking link. You will be shown in
          which locker of the {tenantServiceName} you have chosen the booked
          devices are ready for you. You can open the locker and remove the
          product at the earliest 15 minutes before the start of the usage time.
          <br />
          <br />
          You are requested to check the condition of the product before removal
          for any damage and completeness and to confirm this in advance. Should
          you notice damage or other restrictions, report these within the first
          10 minutes of the usage time using the "Report damage" function.
          <br />
          <br />
          You can find this in the station view under (i). You can enter your
          findings in the text field and send the damage report to us by
          clicking "Confirm".
          <br />
          <br />
          Alternatively, you can call customer support, who will then change the
          booking and block the relevant material. If the damage does not affect
          the usability of the product, the booking can usually be continued,
          otherwise you should return the material to the locker after carrying
          out the damage report and end the usage time. In this case, you will
          receive access to an alternative product if available. Should no
          alternative product be available, you will automatically receive a
          credit for the booked amount.
          <br />
          <br />
          Should you have any questions about this, you can reach us
          continuously under the contact options specified in the app.
          <br />
          <br />
          If you do not submit a damage report within the first 10 minutes of
          the usage time, we assume that the product you found was found
          complete and undamaged in the locker.
        </p>
        <p>
          <strong>8.2 End of Usage Time</strong>
          <br />
          Please return the rented products punctually, completely and in a
          clean condition at the end of the usage time by placing them back in
          the locker and ending the usage time by clicking the "End Rental"
          button and then selecting the option "Open doors & end rental". With
          the completion of the rental, you confirm that no further damage
          occurred to the products during your booking period. Should damage
          occur to the rented products during the usage time or parts of the
          material be lost or go missing, you must inform us of this. Please use
          the "Report damage" function for this. You can describe the problem
          that occurred in the text field provided for this purpose.
          <br />
          <br />
          If a rental is not properly ended as described here, we reserve the
          right to charge for the overbooking time, plus a processing fee of
          €7.90 including currently valid VAT.
          <br />
          <br />
          After the end of the usage time, you can open the locker for an
          additional 15 minutes, during which you can return the rented
          material. After the return time has expired, you can no longer open
          the locker. Please note that personal items placed by you in the
          locker must be removed beforehand.
          <br />
          <br />
          The user must compensate for damages to the provider due to exceeding
          the usage time, even if the excess is caused by another participant
          (see 6.5. of these T&C).
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          9. Code of Conduct and User Liability
        </h2>
        <p>
          <strong>9.1 Safety and Operational Readiness of Products</strong>
          <br />
          The safety and operational readiness of the products are ensured
          through regular inspections. You commit to treating the rental items
          with care. Damage and contamination that occur during your usage time
          will be removed at your expense. The costs for replacing damaged or
          lost material (including theft) will be charged to you. For damage
          reporting obligations, see above under 6.3.
          <br />
          <br />
          If unforeseen circumstances occur that make timely return of the
          rental item impossible, you are obligated to inform us immediately so
          that a simple and cost-effective solution can be brought about. Any
          resulting recovery costs must be borne by you as the user.
          <br />
          <br />
          If you have booked our services for multiple persons, you are jointly
          and severally liable with the respective liable participants. Should
          the damage causator not be identifiable, you are solely liable, unless
          you prove that the damage was not caused or co-caused by the circle of
          participants you selected.
        </p>
        <p>
          <strong>9.4 Use Exclusively According to Intended Purpose</strong>
          <br />
          Please note to use the respective products only according to their
          intended purpose. Should there be uncertainty about the application,
          please read the attached instructions for use in advance or inform
          yourself otherwise about the correct use of the respective products.
          The provider assumes no liability in case of damage cases caused by
          user application errors. The user releases the provider from all
          claims due to accidents, from violation of laws, regulations or other
          provisions in connection with the use of our services by him or
          another participant in this service. We point out the joint and
          several liability of the user with other participants of the service.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          10. Provider Liability
        </h2>
        <p>
          The provider is liable for the slightly negligent breach of essential
          obligations, the breach of which endangers the achievement of the
          contractual purpose, or for the breach of obligations, the fulfillment
          of which enables the proper performance of the contract in the first
          place and on whose compliance the user regularly relies. In these
          cases, however, the provider is only liable for the foreseeable,
          contract-typical damage. The provider is not liable for the slightly
          negligent breach of obligations other than those mentioned in the
          preceding sentences. The above liability limitations do not apply in
          case of injury to life, body and health, for a defect after assumption
          of a guarantee for the condition of the product and in case of
          maliciously concealed defects. Liability under the Product Liability
          Act remains unaffected.
          <br />
          <br />
          Insofar as the seller's liability is excluded or limited, this also
          applies to the personal liability of employees, representatives and
          vicarious agents.
        </p>
        <h2 className="font-semibold text-foreground/90 text-xl leading-[28px] tracking-[-0.015em]">
          11. Final Provisions
        </h2>
        <p>
          Place of jurisdiction and place of performance is the seat of the
          provider, unless otherwise provided by applicable law. The contract
          language is German. There are no oral side agreements. All changes and
          additions to these T&C require text form, whereby email is sufficient.
          Should individual or multiple provisions of this contract be invalid
          or void, this does not affect the validity of the contract in its
          remaining provisions. Any gaps will be replaced by the provision that
          comes closest to the presumed will of the parties. European Commission
          platform for online dispute resolution (ODR) for consumers:{" "}
          <HintsLink
            href="http://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            http://ec.europa.eu/consumers/odr/
          </HintsLink>
          . We are not willing and not obligated to participate in a dispute
          resolution procedure before a consumer arbitration board.
        </p>

        <p className="italic text-sm">
          Status of T&C: 01.03.2025 {companyName}
        </p>
      </div>
    );
  }
};

export default DefaultTermsAndConditions;
